"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _index = _interopRequireDefault(require("./index.js"));

var _globals = require("@insided/shared/utils/globals");

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _utils = require("@insided/deprecated-preact-components/editor/utils");

var _redirect = require("@insided/shared/utils/redirect");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'post-editor';
exports.cssAnchorName = cssAnchorName;

var PostEditor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PostEditor, _Component);

  var _super = _createSuper(PostEditor);

  function PostEditor() {
    var _this$props$data;

    var _this;

    (0, _classCallCheck2.default)(this, PostEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      attachments: [],
      errors: [],
      isLoading: false,
      content: (_this$props$data = _this.props.data) !== null && _this$props$data !== void 0 ? _this$props$data : ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      _this.setState({
        content: content,
        attachments: attachments
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      var _this$props = _this.props,
          onCancel = _this$props.onCancel,
          data = _this$props.data;

      _this.setState({
        content: data !== null && data !== void 0 ? data : ''
      });

      if (typeof onCancel === 'function') {
        onCancel();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(PostEditor, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var postId, _yield$axios$get, attachments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                postId = this.props.postId;

                if (postId) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return _axios.default.get("/attachment/getForPost?postIds=".concat(postId));

              case 5:
                _yield$axios$get = _context.sent;
                attachments = _yield$axios$get.data;

                if (attachments !== null && attachments !== void 0 && attachments[postId]) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                this.setState({
                  attachments: attachments[postId]
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          disableFileAttachments = _this$props2.disableFileAttachments,
          isControl = _this$props2.isControl,
          autoFocus = _this$props2.autoFocus,
          onSuccess = _this$props2.onSuccess,
          onCancel = _this$props2.onCancel,
          data = _this$props2.data;
      var content = this.state.content;
      var submitRequest = (0, _utils.determineRequest)(this.props);
      return (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref) {
        var lock = _ref.lock,
            unlock = _ref.unlock;
        return (0, _preact.h)(_index.default, (0, _extends2.default)({}, _this2.props, {
          disableFileAttachments: disableFileAttachments,
          isControl: isControl,
          autoFocus: !!autoFocus,
          errors: _this2.state.errors,
          isLoading: _this2.state.isLoading,
          attachments: _this2.state.attachments,
          onChange: function onChange(content, attachments) {
            _this2.onChange(content, attachments);

            lock(content, data);
          },
          onCancel: onCancel ? function () {
            unlock();

            _this2.onCancel();
          } : null,
          data: content !== null && content !== void 0 ? content : '',
          onSubmit: /*#__PURE__*/function () {
            var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(content, attachments, hasFileInProgress) {
              var _response, errors, newErrors, _ref3, _response$data$succes, redirectUrl, _error$response$data, _error$response$data$, _error$response$data2, _error$response$data3, _error$response$data4, errorMessage;

              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _this2.setState({
                        isLoading: true
                      });

                      _context2.prev = 1;
                      unlock();
                      _context2.next = 5;
                      return submitRequest(content, attachments.map(function (item) {
                        return JSON.stringify(item);
                      }), hasFileInProgress);

                    case 5:
                      _response = _context2.sent;
                      errors = _response.data.errors;

                      if (!(errors !== null && errors !== void 0 && errors.length)) {
                        _context2.next = 11;
                        break;
                      }

                      newErrors = errors.map(function (error) {
                        return {
                          errorMessage: error
                        };
                      });

                      _this2.setState(function (prevState) {
                        return {
                          errors: prevState.errors.concat(newErrors),
                          isLoading: false
                        };
                      });

                      return _context2.abrupt("return");

                    case 11:
                      (0, _globals.publish)('post_editor_submit', {
                        content: content
                      });

                      if (!_this2.props.redirect) {
                        _context2.next = 15;
                        break;
                      }

                      redirectUrl = (_ref3 = (_response$data$succes = _response.data.success) !== null && _response$data$succes !== void 0 ? _response$data$succes : _response.headers.location) !== null && _ref3 !== void 0 ? _ref3 : '';
                      return _context2.abrupt("return", (0, _redirect.delayedRedirect)(redirectUrl));

                    case 15:
                      onSuccess(content, _response);

                      _this2.setState({
                        errors: []
                      });

                      window.CKEDITOR.instances.editor1.setData('');
                      _context2.next = 25;
                      break;

                    case 20:
                      _context2.prev = 20;
                      _context2.t0 = _context2["catch"](1);
                      lock(content, data);
                      errorMessage = ((_error$response$data = _context2.t0.response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.errors) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.pagetext) || ((_error$response$data2 = _context2.t0.response.data) === null || _error$response$data2 === void 0 ? void 0 : (_error$response$data3 = _error$response$data2.errors) === null || _error$response$data3 === void 0 ? void 0 : _error$response$data3.content) || ((_error$response$data4 = _context2.t0.response.data) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.errors) || "Something's gone wrong";

                      _this2.setState(function (prevState) {
                        return {
                          errors: prevState.errors.concat({
                            errorMessage: errorMessage
                          })
                        };
                      });

                    case 25:
                      _this2.setState({
                        isLoading: false
                      });

                    case 26:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[1, 20]]);
            }));

            return function (_x, _x2, _x3) {
              return _ref2.apply(this, arguments);
            };
          }()
        }));
      });
    }
  }]);
  return PostEditor;
}(_preact.Component);

exports.default = PostEditor;